import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './SecAIPage.css';

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

const SecAIPage = () => {
  const [showModal, setShowModal] = useState(true);
  const [hasPaidTrue, setHasPaidTrue] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);

  const getUserId = () => {
    const user = auth.currentUser;
    return user?.uid;
  };

  const fetchHasPaidTrue = async () => {
    try {
      const userId = getUserId();
      if (!userId) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userDocData = userDocSnapshot.docs[0].data();
        const getHasPaid = userDocData.HasPaid || false;
        setHasPaidTrue(getHasPaid);
      } else {
        console.log('User document not found');
        setHasPaidTrue(false); // default to false if not found
      }
    } catch (error) {
      console.error('Error fetching payment status:', error);
      setHasPaidTrue(false);
    }
  };

  useEffect(() => {
    fetchHasPaidTrue();
  });

  const isDisabled = hasPaidTrue === false;

  const handleContactClick = () => {
    setShowModal(false);
    setShowContactModal(true);
  };

  return (
    <div className="secAIBG">
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}

      <div className="SecAIMainContent">
        <div className="SecAI-container">
          <div className="secAI-card-accent" />
          <br />
          <img src="SecAI.png" alt="Logo" className="SecAI-image" />
          <div className="textContent">
            <h2 className="headingcenter">
              SECAI: Empowering Trusted and Secure AI Through Advanced Threat Intelligence
            </h2>
            <div className="SecAIContainer">
              <div className="SecAI2">
                <div className="SECcolumns">
                  <h2>What is SecAI?</h2>
                  <p>SECAI.ai is a platform designed to support the development and deployment of trusted and responsible AI by focusing on threat intelligence and cybersecurity. It offers capabilities such as rapid threat report generation (under 20 seconds), high CTI accuracy (99.9%), and tracking of over 200 APT groups. By providing comprehensive data sources and analysis of billions of threat entities, SECAI.ai enables developers and organizations to proactively identify and mitigate potential risks associated with AI systems. This helps ensure that AI applications are secure, reliable, and aligned with ethical guidelines, fostering greater trust and responsibility in their use.</p>
                </div>
                <div className="SECcolumns">
                  <h2>Why SecAI?</h2>
                  <p>The benefits of using SECAI.ai for trusted and responsible AI are multifold. Firstly, the platform’s ability to quickly generate threat reports and maintain high accuracy in threat intelligence allows for faster Mean Time To Identification (MTTI) of security vulnerabilities. This proactive approach ensures that AI systems are protected against potential cyberattacks and data breaches, which are critical for maintaining the integrity and trustworthiness of AI applications. Secondly, by tracking a vast number of threat entities and APT groups, SECAI.ai provides developers with the necessary insights to build robust security measures into their AI systems, promoting responsible AI development practices and enhancing overall system resilience.</p>                 
                </div>
              </div>
              <br />
              {hasPaidTrue && (
                <div className="button-group">
                  <a href="https://secai.ai/research" target="_blank" rel="noopener noreferrer">
                    <button className="download-button" disabled={isDisabled}>
                      SecAI
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecAIPage;
